__turbopack_context__.v({
  "container": "_2KwX8a_container",
});
